import { TIP_WIDTH } from "@/constants/tutorial";
import type { TooltipPos } from "@/interfaces/tutorial";

export function measureFpEmailTip(cardHeight: number): number {
  const cta = document.getElementById("fp-email-cta");
  const fallback = Math.floor(window.innerHeight * 0.38);
  if (!cta) return fallback;
  const r = cta.getBoundingClientRect();
  return Math.max(16, r.top + r.height / 2 - cardHeight / 2);
}

export function measureAnchor(): TooltipPos {
  const btn = document.getElementById("tour-customize-btn");
  const fallback: TooltipPos = {
    top: 130,
    left: Math.max(16, window.innerWidth - TIP_WIDTH - 16),
    arrowLeft: TIP_WIDTH - 48,
  };
  if (!btn) return fallback;
  const r = btn.getBoundingClientRect();
  const top = r.bottom + 14;
  const preferredLeft = r.right - TIP_WIDTH;
  const left = Math.max(16, Math.min(preferredLeft, window.innerWidth - TIP_WIDTH - 16));
  const arrowLeft = Math.max(20, Math.min(r.left + r.width / 2 - left - 9, TIP_WIDTH - 28));
  return { top, left, arrowLeft };
}

/**
 * Pin the email-lock tip directly below the locked Email Design tab (`#tour-tab-email`) with its
 * up-arrow aligned to the tab's horizontal center, clamped to the viewport. Mirrors the prototype's
 * `_positionEmailLockTip`. Falls back to the top-left corner if the tab can't be found.
 */
export function measureEmailLockTip(): TooltipPos {
  const tab = document.getElementById("tour-tab-email");
  const fallback: TooltipPos = { top: 130, left: 16, arrowLeft: 28 };
  if (!tab) return fallback;
  const r = tab.getBoundingClientRect();
  const top = r.bottom + 14;
  // Nudge the card left of the tab so the arrow lands near the tab's center, then clamp.
  const preferredLeft = r.left - 24;
  const left = Math.max(16, Math.min(preferredLeft, window.innerWidth - TIP_WIDTH - 16));
  const arrowLeft = Math.max(20, Math.min(r.left + r.width / 2 - left - 9, TIP_WIDTH - 28));
  return { top, left, arrowLeft };
}
